var map = {
	"./af.json": 1056,
	"./am.json": 1057,
	"./ar.json": 1058,
	"./az.json": 1059,
	"./be.json": 1060,
	"./bg.json": 1061,
	"./bn.json": 1062,
	"./bs.json": 1063,
	"./ca.json": 1064,
	"./cs.json": 1065,
	"./cy.json": 1066,
	"./da.json": 1067,
	"./de.json": 1068,
	"./dv.json": 1069,
	"./el.json": 1070,
	"./en.json": 1071,
	"./es.json": 1072,
	"./et.json": 1073,
	"./eu.json": 1074,
	"./fa.json": 1075,
	"./fi.json": 1076,
	"./fr.json": 1077,
	"./gl.json": 1078,
	"./ha.json": 1079,
	"./he.json": 1080,
	"./hi.json": 1081,
	"./hr.json": 1082,
	"./hu.json": 1083,
	"./hy.json": 1084,
	"./id.json": 1085,
	"./is.json": 1086,
	"./it.json": 1087,
	"./ja.json": 1088,
	"./ka.json": 1089,
	"./kk.json": 1090,
	"./km.json": 1091,
	"./ko.json": 1092,
	"./ku.json": 1093,
	"./ky.json": 1094,
	"./lt.json": 1095,
	"./lv.json": 1096,
	"./mk.json": 1097,
	"./ml.json": 1098,
	"./mn.json": 1099,
	"./ms.json": 1100,
	"./nb.json": 1101,
	"./nl.json": 1102,
	"./nn.json": 1103,
	"./no.json": 1104,
	"./pl.json": 1105,
	"./ps.json": 1106,
	"./pt.json": 1107,
	"./ro.json": 1108,
	"./ru.json": 1109,
	"./sd.json": 1110,
	"./sk.json": 1111,
	"./sl.json": 1112,
	"./so.json": 1113,
	"./sq.json": 1114,
	"./sr.json": 1115,
	"./sv.json": 1116,
	"./sw.json": 1117,
	"./ta.json": 1118,
	"./tg.json": 1119,
	"./th.json": 1120,
	"./tr.json": 1121,
	"./tt.json": 1122,
	"./ug.json": 1123,
	"./uk.json": 1124,
	"./ur.json": 1125,
	"./uz.json": 1126,
	"./vi.json": 1127,
	"./zh.json": 1128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1055;